import React from "react";
import { Waypoint } from "react-waypoint";

const ListWaypoint = ({ fetchMore, index, items }) => {
    return items && items.length - 2 === index && <Waypoint onEnter={() => fetchMore && fetchMore()} />;
};

export default ListWaypoint;
